import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import Lucky from '@lucky-canvas/vue'

Vue.use(Lucky)

new Vue({
  render: h => h(App),
}).$mount('#app')
